export const ADITUDE_SLOTS = {
  "display-rr-1": "pb-slot-rightrail-1",
  "display-rr-2": "pb-slot-rightrail-2",
  "display-rr-3": "pb-slot-rightrail-3",
  "display-lr-1": "pb-slot-leftrail-1",
  "display-desktop-anchor": "pb-slot-anchor",
  "display-skin": "pb-slot-CPMStar_Skin",
  "display-desktop-anchor-infeed": "pb-slot-infeed-1",
};
